import { Avatar, Box, Grid } from "@mui/material";
import React from "react";
import { AlertDialog } from "../../../components/dialog";
import { Slider } from "./Slider";
import { ResourceMasterComponentStyles } from "./styles";
export const AssetView = ({ asset }) => {
    const classes = ResourceMasterComponentStyles();
    const [open, setOpen] = React.useState(false);
    const onClose = () => {
        setOpen(false)
    }
    return (
        <>
            <Box sx={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
                <Grid container spacing={1}>
                    <Grid item xs={asset?.length > 1 ? 8 : 12} sx={{backgroundColor:"black"}}>
                        {
                            asset?.length === 1 ?
                                <img src={asset?.[0]?.url} alt="" className={classes.mainImg}/>
                                :
                                <Avatar className={classes.mainImg} src={asset?.[0]?.url}></Avatar>

                        }
                    </Grid>
                    {
                        asset?.[1]?.url &&
                        <Grid item xs={4}>
                            <Avatar className={classes.subImg} src={asset?.[1]?.url}></Avatar>

                            {
                                asset?.[2]?.url &&
                                <Avatar className={classes.subImg} src={asset?.[2]?.url}></Avatar>
                            }
                        </Grid>
                    }
                </Grid>

            </Box >
            <AlertDialog
                header="Asset View"
                open={open}
                onClose={onClose}
                component={
                    <Box height="450px" alignItems="center">
                        <Slider assets={asset} />
                    </Box>
                }
                medium={true}

            />
        </>

    )
}